import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import colors from '../../assets/colors';

const StyledPaper = styled(Paper)({
  maxWidth: '95%',
  margin: 'auto',
  overflow: 'hidden',
  marginTop: '5vh',
  flex: 1,
  padding: '3vh',
  background: colors.paper,
});

export default StyledPaper;
